import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Sep 11 2018
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { User } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { ProfileLayer } from '../..//transportLayers/user/ProfileLayer';
import logger from '../../logger';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of user profiles.
 */

export var ProfileStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(ProfileStore, _BaseStore);

  function ProfileStore() {
    var _this;

    _classCallCheck(this, ProfileStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProfileStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.Profile;
    /** layer contains methods for fletching data */

    _this.profileLayer = new ProfileLayer();
    /** List of user profiles */

    _this.list = new Map();
    return _this;
  }
  /**
   * Fletches all user profiles by their ids
   * returns a promise with Map of user profiles
   */


  _createClass(ProfileStore, [{
    key: "getUsers",
    value: function getUsers(userIds) {
      var _this2 = this;

      return this.profileLayer.getUsers(userIds).then(function (users) {
        runInAction(function () {
          users.forEach(function (user) {
            if (user.id) {
              _this2.list.set(user.id, user);
            }
          });
        });
        return _this2.list;
      });
    }
    /** Loads the users profile */

  }, {
    key: "loadUserProfile",
    value: function loadUserProfile() {
      var _this3 = this;

      return this.profileLayer.loadProfile().then(function (user) {
        runInAction(function () {
          _this3.profile = user;
        });
        return user;
      }).catch(function (error) {
        logger.error('Load user profile failed');
        return error;
      });
    }
  }]);

  return ProfileStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], ProfileStore.prototype, "list", void 0);

__decorate([observable, __metadata("design:type", User)], ProfileStore.prototype, "profile", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", Promise)], ProfileStore.prototype, "getUsers", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], ProfileStore.prototype, "loadUserProfile", null);